import { useEffect, useState, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { useIsMobile } from '../../hooks/useIsMobile'
import { BackBarContainer, BackIconContainer } from './BackTopBar.style'
import { IconLeftArrow } from '../../image'

function BackTopBar () {
  const isMobile = useIsMobile()
  const location = useLocation()
  const [backCtaEnabled, setBackCtaEnabled] = useState(false)

  const isVisible = isMobile && backCtaEnabled && location.pathname === '/login'
  const hasExistingHeader = !location.pathname.match('^/mobile/')

  useEffect(() => {
    setBackCtaEnabled(window.sessionStorage.getItem('back_cta_enabled') === 'true')
  }, [])

  useEffect(() => {
    if (!isVisible) return
    const headerEl = document.getElementById('mobile-header')
    const originalHeaderTop = headerEl ? headerEl.style.top : ''
    if (headerEl && hasExistingHeader) {
      headerEl.style.top = '48px'
    }
    const bodyStyle = document.body.style
    const originalPaddingTop = bodyStyle.paddingTop
    bodyStyle.paddingTop = hasExistingHeader ? '96px' : '48px'
    return () => {
      bodyStyle.paddingTop = originalPaddingTop
      if (headerEl) headerEl.style.top = originalHeaderTop
    }
  }, [isVisible, hasExistingHeader])

  const handleBack = useCallback(() => {
    window.history.back()
  }, [])

  if (!isVisible) return null

  return (
    <BackBarContainer hasExistingHeader={hasExistingHeader}>
      <BackIconContainer onClick={handleBack}>
        <img src={IconLeftArrow} alt='back' />
      </BackIconContainer>
    </BackBarContainer>
  )
}

export default BackTopBar
